export const prepareInitialData = (driver, routeNumber) => ({
  ...driver,
  routeNumber,
});

export const isDriverInputDisabled = (
  isSubmitting,
  isMultiRunRoute,
  isRouteInBuild
) => {
  if (isSubmitting) {
    return true;
  }
  if (isRouteInBuild) {
    return false;
  }
  return isMultiRunRoute;
};
